import { CORE_API_HOST, FORMS_API_HOST, TERRA_API_HOST, TICKETS_API_HOST, VAULT_API_HOST } from "../api-hosts";
import { httpClient } from "./http-client";
export default class ApiService {
    get_claims(req = {}) {
        return httpClient({
            url: `claims/${req.query ? `?${req.query}` : ""}`,
            baseURL: CORE_API_HOST,
            headers: req.headers,
        });
    }
    async get_container(req) {
        return httpClient({
            url: `container-views/${req.id}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        });
    }
    async get_strategix4_data(req = {}) {
        return httpClient({
            url: `https://sensehawk-api.strategix4.com/api/streams/getstream/${req.query ? `?${req.query}` : ""}`,
            data: req.body,
            method: "POST",
        }).then(res => res.data);
    }
    async get_strategix4_token(req = {}) {
        return httpClient({
            url: `external/strategix4/auth/`,
            data: req.body,
            method: "POST",
            baseURL: CORE_API_HOST
        }).then(res => res.data);
    }
    get_project_orthotiles_meta(req) {
        return httpClient({
            url: req.url,
            headers: req.headers,
        });
    }
    async get_report_download_link(req) {
        return httpClient({
            url: req.url,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        });
    }
    async get_element(req) {
        return httpClient({
            url: req.url,
            headers: req.headers,
        });
    }
    async get_tickets_metrics(req = {}) {
        return httpClient({
            url: `metrics/${req.query ? `?${req.query}` : ""}`,
            baseURL: TICKETS_API_HOST,
            headers: req.headers,
        });
    }
    async get_vault_metrics(req = {}) {
        return httpClient({
            url: `metrics/${req.query ? `?${req.query}` : ""}`,
            baseURL: VAULT_API_HOST,
            headers: req.headers,
        });
    }
    // tickets
    async get_tickets(req = {}) {
        return httpClient({
            url: `tickets/${req.query ? `?${req.query}` : ""}`,
            baseURL: TICKETS_API_HOST,
            headers: req.headers,
        });
    }

    async get_folders(req = {}) {
        return httpClient({
            url: `folders/${req.query ? `?${req.query}` : ""}`,
            baseURL: VAULT_API_HOST,
            headers: req.headers,
        });
    }
    getExtraPropsData(req = {}) {
        return httpClient({
            url: `csv/container/${req.container_id}/generate-csv/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
            data: req.body || {},
            method: req.method || "GET"
        });
    }
    get_report_url(req={}){
        return httpClient({
                url: `container-views/${req.container_uid}/projects/${req.project_uid}`,
                baseURL: TERRA_API_HOST,
                method: req.method || "GET",
                headers: req.headers,
        })
    }
    getExtraPropsDataSave(req = {}) {
        return httpClient({
            url: `csv/container/${req.container_id}/import-csv/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
            method: "post",
            data: req.body,
        });
    }
    get_forms(req = {}) {
        return httpClient({
            url: `forms/?status=published${req.query ? '&' + req.query : ''}`,
            method: "GET",
            baseURL: FORMS_API_HOST
        });
    }
    get_filtered_forms(req = {}) {
        return httpClient({
            url: `forms/filter/`,
            method: "POST",
            data: req.body,
            baseURL:FORMS_API_HOST
        });
    }
    get_project_details(req = {}) {
        return httpClient({
            url: `groups/${req.group_id}/projects/${req.id}/${req.query ? `?${req.query}` : ""}`,
        })
    }
}

